import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
  padding-top: var(--space-400);
  padding-bottom: var(--space-400);
  border-radius: var(--border-radius-400);
  background: var(--color-background-secondary);
  border: 1px solid var(--color-border-secondary);
`;
export const Title = styled.div `
  display: flex;
  align-items: center;
  gap: var(--space-200);
  font-size: var(--font-size-500);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
  line-height: var(--line-height-tight);
`;
export const Description = styled.p `
  margin: 0;
  font-size: var(--font-size-400);
  color: var(--color-text-secondary);
  line-height: var(--line-height-normal);
`;
export const ButtonContainer = styled.div `
  display: flex;
  justify-content: flex-start;
  margin-top: var(--space-200);
`;
export const Footer = styled.div `
  margin-top: var(--space-400);
  padding-top: var(--space-400);
  border-top: 1px solid var(--color-border-secondary);
  font-size: var(--font-size-300);
  color: var(--color-text-secondary);
  line-height: var(--line-height-normal);
`;
